import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Asegúrate de importar FontAwesomeIcon
import { faUsers,faFileContract, faBuilding, faStore } from '@fortawesome/free-solid-svg-icons'; // Puedes cambiar el ícono según sea necesario
import './shortcutsModal.css'; // Crea un archivo de estilos para este modal

const ShortcutsModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const role = localStorage.getItem('role');
  
  const hasPermission = (permission) => {
    const permissions = JSON.parse(localStorage.getItem('permissions')) || [];
    return permissions.includes(permission);
  };

  return (
    <div className="shortcuts-modal-overlay" onClick={onClose}>
      <div className="shortcuts-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="shortcuts-modal-header">
          <h3>Atajos</h3>
        </div>
        <div className="shortcuts-list">
          {hasPermission('CUSTOMER_LIST') && (
            <Link to="/Customers" className="shortcut-link-item">
              <div className="shortcut-item">
                <FontAwesomeIcon icon={faUsers} className="shortcut-icon" />
                <span className="shortcut-key">Lista de Clientes</span>
              </div>
            </Link>
          )}
          {(hasPermission('MANAGEMENT_USER_LIST') || hasPermission('PERMISSION_LIST') || hasPermission('ROLE_LIST')
            || hasPermission('DISTRIBUTOR_LIST') || hasPermission('CREDENTIAL_LIST') || hasPermission('PARAMETER_LIST')
            || hasPermission('USER_LIST') || hasPermission('CUSTOMER_MANAGEMENT')
          )
          && (
            <Link to="/Management" className="shortcut-link-item">
              <div className="shortcut-item">
                <FontAwesomeIcon icon={faFileContract} className="shortcut-icon" />
                <span className="shortcut-key">Administración</span>
              </div>
            </Link>
          )}
          {hasPermission('COMPANY_ADMIN_LIST') && (
            <Link to="/CompaniesManagement" className="shortcut-link-item">
              <div className="shortcut-item">
                <FontAwesomeIcon icon={faBuilding} className="shortcut-icon" />
                <span className="shortcut-key">Gestión de Compañías</span>
              </div>
           </Link>
          )}
          {(role === 'CHANEL_ADMIN') && (
            <Link to="/PurchaseList" className="shortcut-link-item">
              <div className="shortcut-item">
                <FontAwesomeIcon icon={faStore} className="shortcut-icon" />
                <span className="shortcut-key">Órdenes</span>
              </div>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default ShortcutsModal;
